<template>
  <PlanSummaryCardText
    :showCouponBadge="hasAppliedCoupon"
    :title="planSummaryTitle"
    :pricing="noPaymentDetails"
    :trialInfo="trialDisplay"
    subheading="Cancel Anytime"
    :secondarySubheading="renewalInfo"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import PlanSummaryCardText from './PlanSummaryCardText.vue'
import { useCouponStore } from '@/store/CouponStore'
import { usePlanStore } from '@/store/PlanStore'
import { useProductStore } from '@/store/ProductStore'
import { useCheckoutStore } from '@/store/CheckoutStore'
import { usePriceStore } from '@/store/PriceStore'
const planStore = usePlanStore()
const productStore = useProductStore()
const couponStore = useCouponStore()
const checkoutStore = useCheckoutStore()
const priceStore = usePriceStore()
const { country } = storeToRefs(checkoutStore)
const { name: productName } = storeToRefs(productStore)
const { selectedPlanLengthDisplay, selectedPlanAutoRenew, selectedPlanIntervalAsNoun } = storeToRefs(planStore)
const { selectedPlanDisplayPrice } = storeToRefs(priceStore)

const { appliedCouponTrial, appliedCouponTrialLengthPlural, hasAppliedCoupon } = storeToRefs(couponStore)

const planSummaryTitle = computed(() => productName.value)

const noPaymentOfferLength = computed(() => (appliedCouponTrial.value ? appliedCouponTrialLengthPlural.value : selectedPlanLengthDisplay.value))
const noPaymentDetails = computed(() => `Access for ${noPaymentOfferLength.value}`)
const trialDisplay = 'starting today.'
const preTaxDetails = computed(() => (country.value === 'US' ? '(pre-tax)' : ''))
const planPricing = computed(() => `${selectedPlanDisplayPrice.value}/${selectedPlanIntervalAsNoun.value} ${preTaxDetails.value}`)
const renewalInfo = computed(() => (selectedPlanAutoRenew.value ? `${planPricing.value} after ${noPaymentOfferLength.value}.` : ''))
</script>
